import {UmpireClub} from '../umpire-club';

export class UmpireUser {
  id!: string;

  type = 'user';

  club?: UmpireClub;

  avatar_url?: string;

  nickname?: string;
}
